(function () {
  function syncClinicianCardHeights(section) {
    var contents = section.querySelectorAll('.clinician-card__content');
    if (!contents.length) return;

    contents.forEach(function (content) {
      content.style.minHeight = '';
    });

    var maxHeight = 0;
    contents.forEach(function (content) {
      var contentHeight = content.offsetHeight;
      if (contentHeight > maxHeight) maxHeight = contentHeight;
    });

    if (!maxHeight) return;

    contents.forEach(function (content) {
      content.style.minHeight = maxHeight + 'px';
    });
  }

  function initClinicianSlider(root) {
    if (typeof Swiper === 'undefined') return;

    var scope = root || document;
    var sections = scope.querySelectorAll('.clinician-slider[data-section-id]');

    sections.forEach(function (section) {
      if (section.dataset.sliderInitialized === 'true') return;

      var swiperEl = section.querySelector('[data-clinician-swiper]');
      if (!swiperEl) return;

      var prevEl = section.querySelector('[data-clinician-prev]');
      var nextEl = section.querySelector('[data-clinician-next]');
      var scrollbarEl = section.querySelector('[data-clinician-scrollbar]');

      var swiper = new Swiper(swiperEl, {
        slidesPerView: 1.39,
        spaceBetween: 16,
        speed: 700,
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl
        },
        scrollbar: {
          el: scrollbarEl,
          draggable: true,
          hide: false
        },
        breakpoints: {
          991: {
            slidesPerView: 'auto',
            spaceBetween: 18
          }
        },
        on: {
          init: function () {
            syncClinicianCardHeights(section);
          },
          resize: function () {
            syncClinicianCardHeights(section);
          },
          slideChangeTransitionEnd: function () {
            syncClinicianCardHeights(section);
          }
        }
      });

      // Re-sync after images load to keep all cards equal height.
      var images = section.querySelectorAll('.clinician-card__media img');
      images.forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', function () {
          syncClinicianCardHeights(section);
        });
      });

      window.addEventListener('load', function () {
        syncClinicianCardHeights(section);
      });

      window.addEventListener('resize', function () {
        syncClinicianCardHeights(section);
      });

      section.dataset.sliderInitialized = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initClinicianSlider(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initClinicianSlider(event.target || document);
  });
})();
